import { IHeaderCommandBarItem } from "azure-devops-ui/HeaderCommandBar";

export const commandBarItems: IHeaderCommandBarItem[] = [
    {
        iconProps: { iconName: "Add" },
        id: "test1",
        isPrimary: true,
        text: "Create"
    },
    {
        iconProps: { iconName: "Share" },
        id: "test2",
        text: "Share"
    }
];
